import { render, staticRenderFns } from "./PrescriptionDetailsPage.vue?vue&type=template&id=3e1903d4&scoped=true"
import script from "./PrescriptionDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PrescriptionDetailsPage.vue?vue&type=script&lang=ts"
import style0 from "./PrescriptionDetailsPage.vue?vue&type=style&index=0&id=3e1903d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1903d4",
  null
  
)

export default component.exports